class Webcam {
    constructor(webcamElement, facingMode = 'user', canvasElement = null, tuningElement=null, snapSoundElement = null) {
        this._webcamElement = webcamElement;
        this._webcamElement.width = this._webcamElement.width || 640;
        this._webcamElement.height = this._webcamElement.height || video.width * (3 / 4);
        this._facingMode = facingMode;
        this._webcamList = [];
        this._streamList = [];
        this._selectedDeviceId = '';
        this._canvasElement = canvasElement;
        this._snapSoundElement = snapSoundElement;
        this._tuningCanvasElement = tuningElement;
        this._value = 0;
    }

    get facingMode(){
        return this._facingMode;
    }

    set facingMode(value){
        this._facingMode = value;
    }

    get webcamList(){
        return this._webcamList;
    }

    get webcamCount(){
        return this._webcamList.length;
    }

    get selectedDeviceId(){
        return this._selectedDeviceId;
    }

    get webcamHeight(){
        return this._webcamElement.height;
    }
    get webcamWidth(){
        return this._webcamElement.width;
    }

    get cameraEl(){
        return this._cameraEl;
    }

    set cameraEl(value){
        this._cameraEl = value;
    }

    /* Get all video input devices info */
    getVideoInputs(mediaDevices){
        this._webcamList = [];
        mediaDevices.forEach(mediaDevice => {
            if (mediaDevice.kind === 'videoinput') {
              this._webcamList.push(mediaDevice);
            }
        });
        if(this._webcamList.length == 1){
            this._facingMode = 'user';
        }
        return this._webcamList;
    }

    /* Get media constraints */
    getMediaConstraints() {
        var videoConstraints = {};
        if (this._selectedDeviceId == '') {
            videoConstraints.facingMode =  this._facingMode;
        } else {
            videoConstraints.deviceId = { exact: this._selectedDeviceId};
        }
        var constraints = {
            video: videoConstraints,
            audio: false
        };
        return constraints;
    }

    /* Select camera based on facingMode */
    selectCamera(){
        let found = false;
        let index = 0;
        for(let webcam of this._webcamList) {
            const webcamLabel = webcam.label.toLowerCase();
            if (this.isMicrosoftDevice(webcamLabel)) {
                if ((this._facingMode == 'user' && webcam.label.toLowerCase().includes('front'))
                    || (this._facingMode == 'enviroment' && webcam.label.toLowerCase().includes('rear'))
                ) {
                    this._selectedDeviceId = webcam.deviceId;
                    found = true;
                    break;
                }
            } else {
                if ((this._facingMode == 'user' && webcam.label.toLowerCase().includes('front'))
                    || (this._facingMode == 'enviroment' && webcam.label.toLowerCase().includes('back'))
                ) {
                    this._selectedDeviceId = webcam.deviceId;
                    found = true;
                    break;
                }
                else if((this._facingMode == 'user' && webcam.label.toLowerCase() == "")
                  || (this._facingMode == 'enviroment' && webcam.label.toLowerCase() == "")
                ) {
                  if(this._facingMode == 'user' && index == 0){
                    this._selectedDeviceId = webcam.deviceId;
                    found = true;
                    break;
                  }
                  else if(this._facingMode == 'enviroment' && index == 1){
                    this._selectedDeviceId = webcam.deviceId;
                    found = true;
                    break;
                  }
                }
            }
            index ++;
        }
    }

    isMicrosoftDevice(driverName){
        let returnable = false;
        if(driverName.search('surface camera') > -1){
            returnable = true;
        }else if (driverName.search('microsoft camera') > -1){
            returnable = true;
        }
        return returnable;
    }

    /* Change Facing mode and selected camera */
    flip(){
        this._facingMode = (this._facingMode == 'user')? 'enviroment': 'user';
        this._webcamElement.style.transform = "";
        this.selectCamera();
    }

    /*
      1. Get permission from user
      2. Get all video input devices info
      3. Select camera based on facingMode
      4. Start stream
    */
    async start(startStream = true) {
        return new Promise((resolve, reject) => {
            this.stop();
            navigator.mediaDevices.getUserMedia(this.getMediaConstraints()) //get permisson from user
                .then(stream => {
                    this._streamList.push(stream);
                    this.info() //get all video input devices info
                        .then(webcams =>{
                            this.selectCamera();   //select camera based on facingMode
                            if(startStream){
                                this.stream()
                                    .then(facingMode =>{
                                        resolve(this._facingMode);
                                    })
                                    .catch(error => {
                                        reject(error);
                                    });
                            }else{
                                resolve(this._selectedDeviceId);
                            }
                        })
                        .catch(error => {
                            reject(error);
                        });
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    /* Get all video input devices info */
    async info(){
        return new Promise((resolve, reject) => {
            navigator.mediaDevices.enumerateDevices()
                .then(devices =>{
                    this.getVideoInputs(devices);
                    resolve(this._webcamList);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    /* Start streaming webcam to video element */
    async stream() {
        return new Promise((resolve, reject) => {
            navigator.mediaDevices.getUserMedia(this.getMediaConstraints())
                .then(stream => {
                    this._streamList.push(stream);
                    this._webcamElement.srcObject = stream;
                    if(this._facingMode == 'user'){
                        this._webcamElement.style.transform = "scale(-1,1)";
                    }
                    this._webcamElement.play();
                    resolve(this._facingMode);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    }

    /* Stop streaming webcam */
    stop() {
        this._streamList.forEach(stream => {
            stream.getTracks().forEach(track => {
                track.stop();
            });
        });
    }
    drawImage(ctx, img, width, height, imageWidth, imageHeight) {
        var x = 0, y = 0, offsetX = 0.5, offsetY = 0.5,
            ratio = Math.min(width / imageWidth, height / imageHeight),
            nw = imageWidth * ratio,
            nh = imageHeight * ratio,
            cx, cy, cw, ch, ar = 1;
     
        if (nw < width) ar = width / nw;                             
        if (Math.abs(ar - 1) < 1e-14 && nh < height) ar = height / nh; 
        nw *= ar;
        nh *= ar;
    
        cw = imageWidth / (nw / width);
        ch = imageHeight / (nh / height);
    
        cx = (imageWidth - cw) * offsetX;
        cy = (imageHeight - ch) * offsetY;
    
        if (cx < 0) cx = 0;
        if (cy < 0) cy = 0;
        if (cw > imageWidth) cw = imageWidth;
        if (ch > imageHeight) ch = imageHeight;
    
        ctx.drawImage(img, cx, cy, cw, ch,  x, y, width, height);
    }
    snap(imageWidth, imageHeight) {
        if(this._canvasElement!=null){
            if(this._snapSoundElement!= null){
                this._snapSoundElement.play();
            }
            this._canvasElement.height = this._webcamElement.scrollHeight;
            this._canvasElement.width = this._webcamElement.scrollWidth;
            let context = this._canvasElement.getContext('2d');
            if(this._facingMode == 'user'){
                context.translate(this._canvasElement.width, 0);
                context.scale(-1, 1);
            }
            context.clearRect(0, 0, this._canvasElement.width, this._canvasElement.height);
            //context.drawImage(this._webcamElement, 0, 0, this._canvasElement.width, this._canvasElement.height);
            this.drawImage(context,this._webcamElement,this._canvasElement.width, this._canvasElement.height, imageWidth, imageHeight)

            this._tuningCanvasElement.height = this._webcamElement.scrollHeight;
            this._tuningCanvasElement.width = this._webcamElement.scrollWidth;
            let tuningContext = this._tuningCanvasElement.getContext('2d');
            if(this._facingMode == 'user'){
              tuningContext.translate(this._tuningCanvasElement.width, 0);
              tuningContext.scale(-1, 1);
            }
            tuningContext.clearRect(0, 0, this._tuningCanvasElement.width, this._tuningCanvasElement.height);
            //tuningContext.drawImage(this._webcamElement, 0, 0, this._tuningCanvasElement.width, this._tuningCanvasElement.height);
            this.drawImage(tuningContext, this._webcamElement,this._tuningCanvasElement.width, this._tuningCanvasElement.height, imageWidth, imageHeight)
            this._cameraEl = _.cloneDeep(this._webcamElement);
            let data = this._canvasElement.toDataURL('image/png');
            return data;
        }
        else{
            throw "canvas element is missing";
        }
    }
    
    imageBrightnessChange(brightness){
      this._canvasElement.height = this._tuningCanvasElement.height;
      this._canvasElement.width = this._tuningCanvasElement.width;
      let context = this._canvasElement.getContext('2d');
      if(this._facingMode == 'user'){
        context.translate(this._canvasElement.width, 0);
        context.scale(-1, 1);
      }
      context.clearRect(0, 0, this._canvasElement.width, this._canvasElement.height);
      // context.drawImage(this._tuningCanvasElement, 0, 0, this._canvasElement.width, this._canvasElement.height);
      this.drawImage(context,this._tuningCanvasElement,this._canvasElement.width, this._canvasElement.height, this._canvasElement.width, this._canvasElement.height)
      context.filter = "brightness(+"+  brightness +"%)";
      //context.drawImage(this._canvasElement, 0, 0, this._canvasElement.width, this._canvasElement.height);
      this.drawImage(context,this._canvasElement,this._canvasElement.width, this._canvasElement.height, this._canvasElement.width, this._canvasElement.height)
      if(this._facingMode == 'user') {
        context.translate(this._canvasElement.width, 0);
        context.scale(-1, 1);
      }

      let data = this._canvasElement.toDataURL('image/png');
      return data;
    }
}
